import { createRouter, createWebHistory } from 'vue-router'

import Genres from '@sw/steps/genres/Genres.vue';
import Title from '@sw/steps/title/Title.vue';
import SelectAgent from '@sw/steps/select-agent/SelectAgent.vue';
import Cover from '@sw/steps/cover/Cover.vue';
import CoreMessage from '@sw/steps/core-message/CoreMessage.vue';
import Description from '@sw/steps/description/Description.vue';
import DetailedSummary from '@sw/steps/detailed-summary/DetailedSummary.vue';
import Upload from '@sw/steps/upload/Upload.vue';
import SubmissionHistory from '@sw/steps/submission-history/SubmissionHistory.vue';
import WhyUs from '@sw/steps/why-us/WhyUs.vue';
import AboutYourself from '@sw/steps/about-yourself/AboutYourself.vue';

// Pages
import PreviewSubmission from '@sw/pages/preview/PreviewSubmission.vue';
import SubmissionWizardStart from '@sw/pages/SubmissionWizardStart.vue';


const routes = [
    { path: '/:companySlug/submit/start', component: SubmissionWizardStart },
    { path: '/:companySlug/submit/preview', component: PreviewSubmission, name: 'preview' },
    { path: '/:companySlug/submit/genres', component: Genres, name: 'genres' },
    { path: '/:companySlug/submit/title', component: Title, name: 'title' },
    { path: '/:companySlug/submit/select-agent', component: SelectAgent, name: 'select-agent' },
    { path: '/:companySlug/submit/cover', component: Cover, name: 'cover' },
    { path: '/:companySlug/submit/core-message', component: CoreMessage, name: 'core-message' },
    { path: '/:companySlug/submit/description', component: Description, name: 'description' },
    { path: '/:companySlug/submit/detailed-summary', component: DetailedSummary, name: 'detailed-summary' },
    { path: '/:companySlug/submit/upload', component: Upload, name: 'upload' },
    { path: '/:companySlug/submit/submission-history', component: SubmissionHistory, name: 'submission-history' },
    { path: '/:companySlug/submit/why-us', component: WhyUs, name: 'why-us' },
    { path: '/:companySlug/submit/about-yourself', component: AboutYourself, name: 'about-yourself' },
]

export default createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {
        // always scroll to top
        // return { top: 0 }
    },
    routes, // short for `routes: routes`
})
